import { render, staticRenderFns } from "./FeedTankCharts.vue?vue&type=template&id=066478f4&"
import script from "./FeedTankCharts.vue?vue&type=script&lang=ts&"
export * from "./FeedTankCharts.vue?vue&type=script&lang=ts&"
import style0 from "./FeedTankCharts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports